/* Barre d'achat collante : apparait quand le bouton principal sort de l'ecran,
   et recopie le prix du lot selectionne. */
(function () {
  if (window.__guardoSticky) return;
  window.__guardoSticky = true;

  function demarre() {
    var barre = document.querySelector('[data-gp-sticky]');
    var principal = document.querySelector('.product-form:not(.sticky-atc) .product-form__submit');
    if (!barre || !principal) return;
    // un ancetre avec transform transforme « fixed » en « absolute » :
    // on sort donc la barre a la racine du document.
    if (barre.parentElement !== document.body) document.body.appendChild(barre);

    // visibilite : liee au bouton principal
    // comme sur la fiche d'origine : rien tant qu'on n'a pas depasse le bouton
    // principal ; la barre n'apparait donc pas en haut de page.
    function ajuste() {
      var r = principal.getBoundingClientRect();
      // visible seulement une fois le bouton principal depasse vers le haut
      barre.hidden = r.bottom > 40;
    }
    ajuste();
    var enAttente = false;
    addEventListener('scroll', function () {
      if (enAttente) return;
      enAttente = true;
      requestAnimationFrame(function () { enAttente = false; ajuste(); });
    }, { passive: true });
    addEventListener('resize', ajuste, { passive: true });

    // prix : repris du lot selectionne
    var zone = barre.querySelector('[data-gp-sticky-prix]');
    var now = barre.querySelector('[data-gp-sticky-now]');
    var full = barre.querySelector('[data-gp-sticky-full]');

    function majPrix() {
      var bloc = document.querySelector('.kaching-bundles__block');
      if (!bloc) return;
      var ligne = bloc.querySelector('.kaching-bundles__bar--selected') || bloc.querySelector('.kaching-bundles__bar');
      if (!ligne) return;
      var p = ligne.querySelector('.kaching-bundles__bar-price');
      var f = ligne.querySelector('.kaching-bundles__bar-full-price');
      if (!p) return;
      now.textContent = p.textContent.trim();
      full.textContent = f ? f.textContent.trim() : '';
      full.hidden = !f;
      zone.hidden = false;
    }

    // le widget de lots se monte apres le chargement : on l'attend
    (function attendLots(n) {
      var bloc = document.querySelector('.kaching-bundles__block');
      if (!bloc) { if (n > 0) setTimeout(function () { attendLots(n - 1); }, 600); return; }
      majPrix();
      new MutationObserver(majPrix).observe(bloc, { subtree: true, childList: true, characterData: true, attributes: true });
      bloc.addEventListener('click', function () { setTimeout(majPrix, 400); });
    })(30);
  }

  function attends(n) {
    if (document.querySelector('[data-gp-sticky]')) { demarre(); return; }
    if (n > 0) setTimeout(function () { attends(n - 1); }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { attends(20); });
  else attends(20);
})();
